// Layout principal - Envuelve todas las páginas
import { Link, useLocation, useOutlet } from 'react-router-dom';
import { AnimatePresence, LayoutGroup, motion } from 'framer-motion';
import Header from './Header';
import CookieBanner from './CookieBanner';
import { usePageMeta } from '../hooks/usePageMeta';

export default function Layout() {
  const location = useLocation();
  usePageMeta();
  const outlet = useOutlet();

  return (
    <div className="min-h-screen flex flex-col bg-ground">
      <Header />
      <CookieBanner />

      {/* La página saliente se queda un instante mientras se desvanece: así el icono
          de un juego puede viajar desde la portada hasta la cabecera del juego */}
      <LayoutGroup>
        <main className="flex-1 relative">
          <AnimatePresence mode="popLayout" initial={false}>
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
            >
              {outlet}
            </motion.div>
          </AnimatePresence>
        </main>
      </LayoutGroup>

      <footer className="border-t border-line/70">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row gap-3 sm:items-center justify-between text-caption text-ink-2">
          <p>© 2026 Jugaly</p>
          <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Legal">
            <Link to="/privacidad" className="hover:text-ink transition-colors">Privacidad</Link>
            <Link to="/terminos" className="hover:text-ink transition-colors">Términos de uso</Link>
            <Link to="/aviso-legal" className="hover:text-ink transition-colors">Aviso legal</Link>
            <a href="mailto:info@jugaly.es" className="hover:text-ink transition-colors">Contacto</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
